import React from "react";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      marginTop: "0.5rem",
      marginBottom: "1.5rem",
      width: "100%",
    },
  },
}));

const Input = ({ field, form: { touched, errors }, ...props }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <TextField
        {...field}
        {...props}
        error={errors[field.name] && touched[field.name]}
        helperText={errors[field.name]}
        label={props.label}
        size="small"
        variant="outlined"
      />
    </div>
  );
};

export default Input;
